export default __webpack_public_path__ + "static/media/F3.cb6d7883.mp3";